// Lets a Timeline "Information" description reference a live Prices-tab
// value instead of a hand-typed dollar figure that silently drifts out of
// sync whenever that price changes. Write {{Item Name}} in the text (the
// exact item name from the Prices tab, e.g. {{School Registration Fee}} or
// {{Participation Fee}}) and it's swapped for the current formatted price
// wherever the description is shown — the admin Timeline table/preview and
// the teacher-portal Dashboard both resolve through this same function.
const TOKEN_PATTERN = /\{\{\s*([^{}]+?)\s*\}\}/g;

// prices: { [item]: price } — the flattened Prices-tab map (see
// EventPricesSection.js/feeConfig.ENTRY_RATES for how each portal builds
// this from its own price fetch). An unmatched token (typo'd or deleted
// price item) is left as literal {{...}} text rather than silently
// collapsing to $0 — a visibly broken token is easier to catch than a fee
// that looks free.
export function resolveTimelineInfo(text, prices) {
  if (!text) return text;
  return text.replace(TOKEN_PATTERN, (match, itemName) => {
    const price = prices?.[itemName.trim()];
    return typeof price === 'number' ? `$${price.toFixed(2)}` : match;
  });
}
